import { useRef } from 'react'
import { Button } from '@postenbring/hedwig-react'
import { useHandleCalculate } from './hooks/useHandleCalculate'

export const CalculateButton = ({ priceEngineProxyUrl, labels }) => {
  const submitButtonRef = useRef(null)

  const { handleCalculate, loading } = useHandleCalculate({ priceEngineProxyUrl, labels })

  const handleClick = (e) => {
    e.preventDefault()
    handleCalculate()
  }

  return (
    <Button
      type="submit"
      ref={submitButtonRef}
      onClick={handleClick}
      disabled={loading}
      fullWidth="mobile"
    >
      {loading ? labels.calculating : labels.calculate}
    </Button>
  )
}
